// Filter existing records rather than copying them into another table.
export function selectDebtTransactions(records) {
  const seen = new Set();
  return records.filter(record => {
    const matches = [record.expense_category, record.expense_subcategory, record.description]
      .some(value => /debt|borrow|\bdept\b/i.test(String(value ?? '')));
    if (!matches) return false;
    // IDs identify transactions; equal amounts/names do not imply duplicates.
    if (record.id == null) return true;
    const id = String(record.id);
    if (seen.has(id)) return false;
    seen.add(id);
    return true;
  });
}
